export default __webpack_public_path__ + "alberta-article.bed208c58884ede7689f.svg";